import { formatIsoDateOnlyShort } from '@/app/utils/formatDate';
import { AgreementHeaderLayout } from './AgreementHeaderLayout';
import { AgreementStatusBadge } from './AgreementStatusBadge';
import type { LeftToPayDisplay } from '../utils/leftToPayDisplay';
import type { Agreement } from '../types/agreements.types';

interface Props {
    agreement: Agreement;
    availableBalance: string | null;
    leftToPay: LeftToPayDisplay;
}

export function AgreementHeader({ agreement, availableBalance, leftToPay }: Props) {
    // F7: startDate is null until activation — render "Not started" rather
    // than an empty cell, which is also the correct rendering for a draft.
    const startDateDisplay = agreement.startDate
        ? formatIsoDateOnlyShort(agreement.startDate)
        : 'Not started';

    return (
        <AgreementHeaderLayout
            reference={agreement.agreementRef}
            badges={<AgreementStatusBadge status={agreement.status} />}
            startDate={startDateDisplay}
            availableBalance={availableBalance}
            leftToPay={leftToPay.hidden ? null : leftToPay.text}
        />
    );
}
